import {Button, Col, Modal, Radio, Row} from 'antd';
import React from 'react';

import acceleratePlanIcon from '../../assets/images/accelerate_plan.png';
import corePlanIcon from '../../assets/images/core_plan.png';
import {ReactComponent as DoubleCheck} from '../../assets/svg/double-check.svg';
import {CONSTANTS} from '../../utils';
import Plan from './Plan';

import './ChoosePlanGxModal.scss';

export const ChoosePlanGxModal = ({visible, onCancel, period, onChangePeriod, onClick}) => (
  <Modal open={visible} footer={null} destroyOnClose={true} onCancel={onCancel} width={1000} title="Checkout">
    <div className="plans_container gx">
      <Row justify="center" style={{marginBottom: 45}}>
        <Radio.Group className="choose_plan" value={period} buttonStyle="solid" onChange={onChangePeriod}>
          <Radio.Button value="monthly">Monthly</Radio.Button>
          <Radio.Button value="quarterly">Quarterly</Radio.Button>
          <Radio.Button value="annual">Annual</Radio.Button>
        </Radio.Group>
      </Row>
      <Row gutter={[32, 8]}>
        {GX_PLANS.map(plan => (
          <Col key={plan.key} span={12}>
            <Plan
              plan={plan}
              isPopular={plan.key === CONSTANTS.BILLING.PLANS.ACCELERATE}
              period={period}
              isCollapsable={plan.key === CONSTANTS.BILLING.PLANS.ACCELERATE}
              highlighted={plan.key === CONSTANTS.BILLING.PLANS.ACCELERATE}
              button={
                <div className="plan_bottom">
                  <Button onClick={() => onClick(plan)} type="primary">
                    {plan.button}
                  </Button>
                </div>
              }
            />
          </Col>
        ))}
      </Row>
    </div>
  </Modal>
);

export const GX_PLANS = [
  {
    key: CONSTANTS.BILLING.PLANS.ACCELERATE,
    title: 'Accelerate',
    prices: {
      monthly: {
        price: '$299',
        description: '/per month',
      },
      quarterly: {
        price: '$266',
        description: '/per month',
      },
      annual: {
        price: '$217',
        description: '/per month',
      }
    },
    button: 'Get Started Now',
    icon: <img src={acceleratePlanIcon} alt="accelerate plan" />,
    features: (
      <>
        <div className="caption">Account Safety</div>
        <ul>
          <li>Cloud-based platform</li>
          <li>Country-specific dedicated IP address</li>
          <li>Seamless profile opening with consistent IP usage</li>
          <li>Automated LinkedIn profile warming</li>
          <li>Advanced algorithms for managing activity limits</li>
          <li>Emulation of human-like actions</li>
        </ul>
        <div className="caption">High Conversion Outreach</div>
        <ul>
          <li>Campaign prioritization and organization</li>
          <li>Comprehensive, step-by-step campaign analytics</li>
          <li>Unified dashboard for complete visibility</li>
          <li>Flexible scheduling options</li>
          <li>Campaign restoration and recovery features</li>
        </ul>
        <div className="caption">Team Collaboration</div>
        <ul>
          <li>Personalized Message Sequences</li>
          <li>Unlimited templates library</li>
          <li>Tags and notes for conversation tracking</li>
          <li>Built-in duplicate detection</li>
          <li>CRM integration capabilities</li>
        </ul>
        <div className="caption">AI features</div>
        <ul>
          <li>AI-driven hot lead identification</li>
          <li>AI-assisted rapid campaign creation</li>
        </ul>
        <div className="caption">Killer Campaigns &amp; Seamless Integrations</div>
        <ul>
          <li>Website Visitors Campaign via Instantly</li>
          <li>API/Webhook/Zapier Campaign Sources</li>
          <li>Upload your own list</li>
          <li>Retargeting Google Ads, Meta Ads, LinkedIn Ads, and more</li>
          <li>Sales Navigator LinkedIn Search</li>
          <li>Nurturing Campaigns</li>
          <li>Email Automation via Instantly</li>
        </ul>
      </>
    ),
  },
  {
    key: CONSTANTS.BILLING.PLANS.ENTERPRISE,
    title: 'Enterprise',
    prices: null,
    button: 'Get Demo Now',
    icon: <img src={corePlanIcon} alt="enterprise plan" />,
    features: (
      <>
        <div className="included">
          <DoubleCheck /> Everything in Accelerate
        </div>
        <div className="caption">VIP features</div>
        <ul>
          <li>
            <span style={{textDecoration: 'underline'}}>Dedicated Growth Expert</span>
          </li>
          <li>1:1 Training Sessions</li>
          <li>Priority Support</li>
          <li>Campaign Review &amp; Optimization</li>
          <li>Profile Review &amp; Optimization</li>
          <li>API/CRM Assisted Integration</li>
          <li>Executive Analytics</li>
          <li>Unlimited Outreach</li>
          <li>Data Credits</li>
          <li>Whitelabel (10+ users required)</li>
        </ul>
      </>
    ),
  },
];
